import styled from "styled-components"
import EditIcon from "components/icons/EditIcon"
import DeleteIcon from "components/icons/DeleteIcon"

const ContentColumn = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 112px;
  width: 100%;
`

const ContentRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: fit-content;
`

const InlineButton = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: fit-content;
`

interface ActionButtonProps {
  onClick?: () => void
  children: React.ReactNode
}

const ActionButton = (props: ActionButtonProps) => {
  const { onClick, children } = props

  return <InlineButton onClick={onClick}>{children}</InlineButton>
}

interface CellActionButtonsProps {
  onClickEdit?: () => void
  onDelete?: () => void
}

export const CellActionButtons = (props: CellActionButtonsProps) => {
  const { onClickEdit, onDelete } = props

  return (
    <ContentColumn>
      <ContentRow>
        <ActionButton onClick={onClickEdit}>
          <EditIcon />
        </ActionButton>
        {onDelete && (
          <ActionButton onClick={onDelete}>
            <DeleteIcon />
          </ActionButton>
        )}
      </ContentRow>
    </ContentColumn>
  )
}
